import React from "react";
import {grey} from "@mui/material/colors";
import {createTheme, ThemeProvider} from "@mui/material";
import Box from "@mui/material/Box";


// Defined outside the component so neither the theme object nor the sx value
// is recreated on every render.
const rootSx = {zIndex: 1, top: 0, right: 0, left: 0, bottom: 0};

export const themeOptions = {
    palette: {
        primary: {
            main: "#673AB7",
            light: "#D1C4E9",
            dark: "#512DA8",
        },
        secondary: {
            main: "#009688",
        },
        background: {
            default: grey[100],
        },
    },
    // MUI 9 removes the browser outline on buttons and only draws a keyboard focus ring when the
    // theme opts in; `true` gives a 2px ring in the primary color.
    focusVisible: true,
    components: {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: '2.5rem',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: "filled",
                color: "secondary",
            },
        },
        MuiFormLabel: {
            defaultProps: {
                color: "secondary",
            },
        },
        MuiSelect: {
            defaultProps: {
                variant: "filled",
                color: "secondary",
            },
        },
    },
};

// createTheme is expensive — hoist it outside the component so it runs once
// at module load time instead of on every render of <Theme>.
const appTheme = createTheme(themeOptions);

export const Theme = ({children}) => {
    return (
        <ThemeProvider theme={appTheme}>
            <Box sx={rootSx}>{children}</Box>
        </ThemeProvider>
    );
};
